import React from "react";

import { OutOfCadenceEntity } from "@mapmycustomers/shared/types/entity/activities/OutOfCadenceEntity";
import { Modal } from "@mapmycustomers/ui";

import styles from "./CadenceModal.module.scss";
import EntitiesTable from "./EntitiesTable";
import Title from "./Title";

interface Props {
  cadencedAt: string;
  entities: OutOfCadenceEntity[];
  loading?: boolean;
  onHide: () => void;
  title?: string;
}

const CadenceModal = ({ cadencedAt, entities, loading, onHide, title }: Props) => (
  <Modal
    footer={null}
    onCancel={onHide}
    title={<Title cadencedAt={cadencedAt} title={title} />}
    visible
    width="clamp(500px, 80vw, 1280px)"
  >
    <EntitiesTable
      cadencedAt={cadencedAt}
      className={styles.table}
      entities={entities}
      loading={loading}
    />
  </Modal>
);

export default CadenceModal;
